

export function readStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("adm_panel_user") || "{}");
  } catch {
    return {};
  }
}

export function normaliseItems(items) {
  return (Array.isArray(items) ? items : []).map((s) => String(s).toLowerCase());
}

// The sidebar's rule: the page is granted to the user AND enabled on the channel.
export function canOpen(userItems, channelItems, page) {
  const key = String(page || "").toLowerCase();
  if (!key) return false;
  return (
    normaliseItems(userItems).includes(key) &&
    normaliseItems(channelItems).includes(key)
  );
}

// The channel list pins at most this many favourites above everything else.
const MAX_PINNED_FAVOURITES = 4;


export function channelsInDisplayOrder(user) {
  const clean = (arr) =>
    (Array.isArray(arr) ? arr : [])
      .map((x) => String(x || "").trim())
      .filter(Boolean);

  const channels = [...new Set(clean(user?.channels))];
  const present = new Set(channels);
  const favourites = clean(user?.favchannels)
    .filter((id) => present.has(id))
    .slice(0, MAX_PINNED_FAVOURITES);

  return [...new Set([...favourites, ...channels])];
}
